import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { ChangePasswordForm } from './change-password-form/ChangePasswordForm'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'

function ProfilePasswordPage() {
  return (
    <PageContainer className="flex flex-col last:grow gap-10 w-full border-b pt-10 pb-15 md:pl-40 md:pr-15">
      <HeadingThree>Vytvor nové heslo</HeadingThree>
      <ChangePasswordForm />
    </PageContainer>
  )
}

export default ProfilePasswordPage
